import { useEffect, useState } from "react";
import LogoLoader from "~/components/LogoLoader";
import { cn } from "~/lib/utils";

interface LoadingScreenProps {
  className?: string;
  showText?: boolean;
  text?: string;
}

const defaultMessages = ["We maken verbinding", "We halen je gegevens op"];

export function LoadingScreen({ className, showText = true, text }: LoadingScreenProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const messages = text ? [text] : defaultMessages;

  useEffect(() => {
    if (!showText || text) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % messages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [showText, text, messages.length]);

  return (
    <div
      className={cn(
        "flex items-center justify-center pt-20 lg:min-h-screen lg:pt-0",
        className,
      )}
    >
      <div className="flex flex-col items-center gap-8 text-center">
        <LogoLoader />
        {showText && (
          <div className="relative h-5 w-72">
            {messages.map((message, index) => (
              <span
                key={message}
                className={cn(
                  "absolute inset-0 text-sm font-medium transition-opacity duration-500",
                  index === currentIndex ? "opacity-100" : "opacity-0",
                )}
              >
                <span
                  className={cn(
                    "shimmer-text",
                    index === currentIndex && "animate-shimmer",
                  )}
                >
                  {message}
                </span>
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
